import React from 'react';

const BREAKER = '\\n';

export const multipleLines = translation =>
  translation.split(BREAKER).reduce((acc, text, index) => (acc ? [...acc, <br key={index} />, text] : [text]), null);
